// extracted by mini-css-extract-plugin
module.exports = {"crumbs":"Breadcrumbs_crumbs__c6r0q","icon":"Breadcrumbs_icon__PgKM6","crumb":"Breadcrumbs_crumb__BXgaU","activeCrumb":"Breadcrumbs_activeCrumb__E6hhB Breadcrumbs_crumb__BXgaU"};